/**
 * @maxime/shared — moteur de jeu pur et types partagés.
 *
 * Ce fichier ne fait plus que **ré-exporter** (M1.1) : la définition de référence des types
 * est `engine/types.ts`, recopiée de SPEC-MOTEUR §1.
 */
export const GAME_NAME = "MaximeApp";
export const ENGINE_VERSION = "0.0.1";
/** Objectif affiché dès le tutoriel (PLAN §1). */
export const OBJECTIF = 1_000_000;
// — Moteur (SPEC-MOTEUR) —
export * from "./engine/types.js";
// `resolve` et la surface publique du moteur (§13) : c'est ce que le serveur, le client
// (previews non autoritatives) et `simulate.ts` consomment.
export * from "./engine/index.js";
// — Schémas de contenu (SPEC-CONTENU) —
// Purs (Zod uniquement) : le serveur en a besoin au boot (SPEC-API §8.1) et le client pour
// `GET /api/content`. `content/load.js` n'est PAS ré-exporté ici : il lit le système de
// fichiers, et le barrel est importé par le client — on l'importe par son chemin depuis le
// serveur et `simulate.ts`.
export * from "./content/schema.js";
export * from "./content/montage-patterns.js";
// — L'écriture de l'Atelier : un jeu de mots qui tombent (⟦C52 · A-170 §1⟧) —
// Pur : le serveur le fait tourner pour générer et noter, le bac à sable du client pour jouer.
export * from "./atelier/blocs.js";
export * from "./atelier/manche.js";
export * from "./atelier/joueur.js";
// Mini-jeux de l'Atelier dont la logique est PARTAGÉE entre le serveur et le client
// ⟦C53 · A-170 §2⟧ « La prise parfaite » : la position du curseur est une fonction du temps que le
// serveur rejoue et que le client affiche, un seul module, pas deux jumeaux.
export * from "./atelier/prise-parfaite.js";
//# sourceMappingURL=index.js.map